'use client'
import { forwardRef, Stepper as ChakraStepper } from '@chakra-ui/react'
import { LegacyRef } from 'react'

import { StepperProps } from './Stepper.types'

export default forwardRef(function Stepper(
  props: StepperProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraStepper {...props} ref={ref} translate="no" />
})
